export const apiErrorsToString = response => {
  let apiErrors = '';
  const errObject = response.error.errors;
  for (const key in errObject) {
    apiErrors += `${errObject[key].join('\n')}\n`;
  }
  return apiErrors;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/apiErrorsToString.ts